import React, { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { API_URL } from "../config";
import axios from "axios";

ChartJS.register(ArcElement, Tooltip, Legend);

const CashFlowChart = ({ cashFlowSubscriptionReport }) => {
    const chartData = {
        labels: cashFlowSubscriptionReport.map((item) => item.service_name),
        datasets: [
            {
                data: cashFlowSubscriptionReport.map((item) => item.amount),
                backgroundColor: cashFlowSubscriptionReport.map((item) => item.colorcode ? `#${item.colorcode}` : '#666666'),
            },
        ],
    };

    if (!cashFlowSubscriptionReport.length) return <p>No subscription data available.</p>;

    return (
        <div style={{ maxWidth: "400px", margin: "0 auto" }}>
            <Doughnut data={chartData} />
        </div>
    );
}
export default CashFlowChart;
